import { useContext } from 'react';
import { BaseForecastContext } from '../contexts/BaseForecastContextDef';

export function useBaseForecast() {
  const ctx = useContext(BaseForecastContext);
  if (!ctx) {
    throw new Error(
      'useBaseForecast must be used within a BaseForecastProvider',
    );
  }
  return ctx;
}
